/** Label & warna status booking/payment dalam bahasa Indonesia. */

export const BOOKING_STATUS_META: Record<string, { label: string; tone: string }> = {
  PENDING_PAYMENT: { label: "Menunggu Pembayaran", tone: "amber" },
  CONFIRMED: { label: "Terkonfirmasi", tone: "blue" },
  CHECKED_IN: { label: "Check-in", tone: "teal" },
  IN_PROGRESS: { label: "Sedang Berjalan", tone: "teal" },
  COMPLETED: { label: "Selesai", tone: "green" },
  CANCELLED: { label: "Dibatalkan", tone: "red" },
  EXPIRED: { label: "Kadaluarsa", tone: "gray" },
  NO_SHOW: { label: "Tidak Hadir", tone: "red" },
};

export const PAYMENT_STATUS_META: Record<string, { label: string; tone: string }> = {
  PENDING: { label: "Belum Dibayar", tone: "amber" },
  PAID: { label: "Lunas", tone: "green" },
  FAILED: { label: "Gagal", tone: "red" },
  EXPIRED: { label: "Kadaluarsa", tone: "gray" },
  REFUNDED: { label: "Dikembalikan", tone: "gray" },
};

export function statusLabel(kind: "booking" | "payment", value: string): string {
  const map = kind === "booking" ? BOOKING_STATUS_META : PAYMENT_STATUS_META;
  return map[value]?.label ?? value;
}

export function StatusPill({ kind, value }: { kind: "booking" | "payment"; value: string }) {
  const map = kind === "booking" ? BOOKING_STATUS_META : PAYMENT_STATUS_META;
  const meta = map[value] ?? { label: value, tone: "gray" };
  return <span className={`status-pill tone-${meta.tone}`}>{meta.label}</span>;
}
